import SelectDistrict from "../../components/selectDistrict";
import React, {useEffect} from "react";

import "./style.scss"
import {useDispatch, useSelector} from "react-redux";
import {clearCurrentDistrictSelected} from "../../actions/districts";
import SelectDistrictForm from "../../components/selectDistrictForm";
import {useNavigate} from "react-router-dom";
import {route as MY_REPORTS_ROUTE} from "../myReports";
import {userCanAccess} from "../../utils/users";

export const route = '/switch-districts';

const SwitchDistricts = (props) => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const currentDistrictSelected = useSelector((state) => state.districts.currentDistrictSelected);
  const currentUserComposite = useSelector((state) => state.session.currentUserComposite);

  useEffect(() => {
      if(currentDistrictSelected === true) {
        dispatch(clearCurrentDistrictSelected());
        navigate(MY_REPORTS_ROUTE);
      }
    }
  );

  return (
    <div className='main-content'>
      <SelectDistrictForm canAddDistrict={userCanAccess(currentUserComposite, 'add-district')}/>
    </div>
  );
}

export default SwitchDistricts;
